// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";

const $ = jQuery;

$( () => {

  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );

  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

} );
